<template>
  <v-container 
    fluid 
    fill-height>
    <v-layout 
      align-center 
      justify-center>
      <v-flex 
        xs12 
        sm6>
        <v-card>
          <v-card-title 
            primary-title
            class="title grey--text">
            <span >
              Welcome {{ user.displayName }}
            </span>
          </v-card-title>
          <v-card-text v-html="welcome"/>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    welcome() {
      return this.$store.getters.getConfig.welcome;
    }
  }
};
</script>
